import React, { FC, memo } from 'react';

import { TEXTS } from 'application/pages/texts';
import { useSearchParams } from 'application/providers/RouterProvider';

import { SelectedPoint } from '../../types';

import styles from './index.module.scss';

interface ModalDescriptionProps {
  selectedPoints: SelectedPoint[];
}

const ModalDescription: FC<ModalDescriptionProps> = ({ selectedPoints }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  if (selectedPoints.length > 1) {
    return TEXTS.MODAL_BIND_SUCCESS_DESC;
  }

  const success = searchParams.get('success');

  if (success) {
    setSearchParams(undefined);

    return TEXTS.MODAL_BIND_SUCCESS_DESC;
  }

  const isPointEnabled = selectedPoints[0].isEnabled === true;

  const successBindStreamDescription = isPointEnabled
    ? TEXTS.MODAL_BIND_SUCCESS_DESC
    : TEXTS.MODAL_BIND_SUCCESS_NON_ACTIVE_DESC;

  return <div className={styles.description}>{successBindStreamDescription}</div>;
};

export default memo(ModalDescription);
